module.exports = __webpack_public_path__ + "static/media/receivership-order-dated-february-5-2024.8c8c28cb.pdf";